<div *ngIf="deletedTripsLoading">Loading...</div>
<div *ngIf="deletedTripsLoaded">
  <div *ngIf="!deletedTrips || (deletedTrips && deletedTrips.length == 0)">
    No trips have been deleted
  </div>

  <div
    class="skeleton-container"
    infiniteScroll
    [infiniteScrollThrottle]="500"
    [scrollWindow]="false"
    (scrolled)="skeletonsNextPage.emit()"
  >
    <mat-accordion>
      <mat-expansion-panel
        *ngFor="let deletedTrip of deletedTrips"
        (opened)="deletedTripOpened.emit(deletedTrip.id)"
      >
        <mat-expansion-panel-header>
          Trip ID: {{ deletedTrip.customTripId }}
          <span *ngIf="deletedTrip.tailNumber"> , {{ deletedTrip.tailNumber }} </span>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <!-- Trip Audit History -->
          <sd-portal-audit-detail-list-v2
            [isTall]="true"
            [loading]="tripLogsLoading"
            [loaded]="tripLogsLoaded"
            [audits]="tripLogs"
            [hasMore]="tripLogsHasMore"
            (nextPage)="deletedTripNextPage.emit(deletedTrip.id)"
            noAuditsMessage="No audit records for this trip"
          ></sd-portal-audit-detail-list-v2>

          <!-- Legs Section -->
          <mat-accordion class="leg-container">
            <div *ngIf="deletedTripLegsLoading">Loading legs...</div>
            <div *ngIf="!deletedTripLegsLoading">
              <div *ngIf="!deletedTripLegs || deletedTripLegs.length == 0">
                No legs found for this trip
              </div>
              <mat-expansion-panel
                *ngFor="let leg of deletedTripLegs"
                (opened)="leg.eventId && legEventLogsOpened.emit(leg.eventId); legFlightLogsOpened.emit(leg.flightId)"
              >
                <mat-expansion-panel-header>
                  Leg {{ leg.legNumber }}
                  <span *ngIf="leg.departureAirport && leg.arrivalAirport">
                    , {{ leg.departureAirport }} ⟹ {{ leg.arrivalAirport }}
                  </span>
                  <span>&nbsp;(Deleted)</span>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <mat-accordion class="nested-accordion">
                    <!-- Dep/Arr Time Section -->
                    <mat-expansion-panel
                      *ngIf="leg.eventId"
                      class="nested-panel"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>Dep / Arr Time</mat-panel-title>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent>
                        <sd-portal-audit-detail-list-v2
                          [loading]="legEventLogsLoading"
                          [loaded]="legEventLogsLoaded"
                          [audits]="legEventLogs"
                          [hasMore]="legEventLogsHasMore"
                          (nextPage)="legEventLogsNextPage.emit(leg.eventId)"
                          noAuditsMessage="No audit records for dep/arr time"
                        ></sd-portal-audit-detail-list-v2>
                      </ng-template>
                    </mat-expansion-panel>

                    <!-- Details Section (now at same level as Dep/Arr Time) -->
                    <mat-expansion-panel
                      class="nested-panel"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>Details</mat-panel-title>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent>
                        <sd-portal-audit-detail-list-v2
                          [loading]="legFlightLogsLoading"
                          [loaded]="legFlightLogsLoaded"
                          [audits]="legFlightLogs"
                          [hasMore]="legFlightLogsHasMore"
                          (nextPage)="legFlightLogsNextPage.emit(leg.flightId)"
                          noAuditsMessage="No audit records for flight details"
                        ></sd-portal-audit-detail-list-v2>
                      </ng-template>
                    </mat-expansion-panel>

                    <!-- Fuel Section -->
                    <mat-expansion-panel
                      *ngIf="leg.departureFuelId"
                      class="nested-panel"
                      (opened)="legFuelLogsOpened.emit(leg.departureFuelId)"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>Fuel</mat-panel-title>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent>
                        <sd-portal-audit-detail-list-v2
                          [loading]="legFuelLogsLoading"
                          [loaded]="legFuelLogsLoaded"
                          [audits]="legFuelLogs"
                          [hasMore]="legFuelLogsHasMore"
                          (nextPage)="legFuelLogsNextPage.emit(leg.departureFuelId)"
                          noAuditsMessage="No audit records for fuel"
                        ></sd-portal-audit-detail-list-v2>
                      </ng-template>
                    </mat-expansion-panel>

                    <!-- Crew Members Section -->
                    <mat-expansion-panel
                      class="nested-panel"
                      (opened)="flightCrewMembersOpened.emit(leg.flightId)"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>Crew Members</mat-panel-title>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent>
                        <div *ngIf="flightCrewMembersLoading">Loading...</div>
                        <div *ngIf="flightCrewMembersLoaded">
                          <div *ngIf="!flightCrewMembers || flightCrewMembers.length === 0">
                            No crew members found
                          </div>
                          <mat-accordion *ngIf="flightCrewMembers && flightCrewMembers.length > 0">
                            <mat-expansion-panel
                              *ngFor="let crew of flightCrewMembers"
                              class="nested-panel"
                              (opened)="crewLogsOpened.emit(crew.crewId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>{{ crew.firstName }} {{ crew.lastName }}</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="crewLogsLoading"
                                  [loaded]="crewLogsLoaded"
                                  [audits]="crewLogs"
                                  [hasMore]="crewLogsHasMore"
                                  (nextPage)="crewLogsNextPage.emit(crew.crewId)"
                                  noAuditsMessage="No audit records for crew member"
                                ></sd-portal-audit-detail-list-v2>

                                <!-- Crew Catering (Departure) -->
                                <mat-accordion *ngIf="crew.departureCateringId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="crewCateringLogsOpened.emit(crew.departureCateringId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Catering (Departure)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="crewCateringLogsLoading"
                                        [loaded]="crewCateringLogsLoaded"
                                        [audits]="crewCateringLogs"
                                        [hasMore]="crewCateringLogsHasMore"
                                        (nextPage)="crewCateringLogsNextPage.emit(crew.departureCateringId)"
                                        noAuditsMessage="No audit records for catering"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>

                                <!-- Crew Hotel (Departure) -->
                                <mat-accordion *ngIf="crew.departureHotelId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="crewHotelLogsOpened.emit(crew.departureHotelId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Hotel (Departure)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="crewHotelLogsLoading"
                                        [loaded]="crewHotelLogsLoaded"
                                        [audits]="crewHotelLogs"
                                        [hasMore]="crewHotelLogsHasMore"
                                        (nextPage)="crewHotelLogsNextPage.emit(crew.departureHotelId)"
                                        noAuditsMessage="No audit records for hotel"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>

                                <!-- Crew Hotel (Arrival) -->
                                <mat-accordion *ngIf="crew.arrivalHotelId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="crewHotelLogsOpened.emit(crew.arrivalHotelId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Hotel (Arrival)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="crewHotelLogsLoading"
                                        [loaded]="crewHotelLogsLoaded"
                                        [audits]="crewHotelLogs"
                                        [hasMore]="crewHotelLogsHasMore"
                                        (nextPage)="crewHotelLogsNextPage.emit(crew.arrivalHotelId)"
                                        noAuditsMessage="No audit records for hotel"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>

                                <!-- Crew Transportation (Departure) -->
                                <mat-accordion *ngIf="crew.departureTransportationId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="crewTransportationLogsOpened.emit(crew.departureTransportationId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Transportation (Departure)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="crewTransportationLogsLoading"
                                        [loaded]="crewTransportationLogsLoaded"
                                        [audits]="crewTransportationLogs"
                                        [hasMore]="crewTransportationLogsHasMore"
                                        (nextPage)="crewTransportationLogsNextPage.emit(crew.departureTransportationId)"
                                        noAuditsMessage="No audit records for transportation"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>

                                <!-- Crew Transportation (Arrival) -->
                                <mat-accordion *ngIf="crew.arrivalTransportationId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="crewTransportationLogsOpened.emit(crew.arrivalTransportationId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Transportation (Arrival)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="crewTransportationLogsLoading"
                                        [loaded]="crewTransportationLogsLoaded"
                                        [audits]="crewTransportationLogs"
                                        [hasMore]="crewTransportationLogsHasMore"
                                        (nextPage)="crewTransportationLogsNextPage.emit(crew.arrivalTransportationId)"
                                        noAuditsMessage="No audit records for transportation"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>
                          <button
                            *ngIf="flightCrewMembersHasMore"
                            mat-button
                            color="primary"
                            (click)="flightCrewMembersNextPage.emit(leg.flightId)"
                          >
                            Load More
                          </button>
                        </div>
                      </ng-template>
                    </mat-expansion-panel>

                    <!-- Passengers Section -->
                    <mat-expansion-panel
                      class="nested-panel"
                      (opened)="flightPassengersOpened.emit(leg.flightId)"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>Passengers</mat-panel-title>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent>
                        <div *ngIf="flightPassengersLoading">Loading...</div>
                        <div *ngIf="flightPassengersLoaded">
                          <div *ngIf="!flightPassengers || flightPassengers.length === 0">
                            No passengers found
                          </div>
                          <mat-accordion *ngIf="flightPassengers && flightPassengers.length > 0">
                            <mat-expansion-panel
                              *ngFor="let pax of flightPassengers"
                              class="nested-panel"
                              (opened)="passengerLogsOpened.emit(pax.paxId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>{{ pax.firstName }} {{ pax.lastName }}</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="passengerLogsLoading"
                                  [loaded]="passengerLogsLoaded"
                                  [audits]="passengerLogs"
                                  [hasMore]="passengerLogsHasMore"
                                  (nextPage)="passengerLogsNextPage.emit(pax.paxId)"
                                  noAuditsMessage="No audit records for passenger"
                                ></sd-portal-audit-detail-list-v2>

                                <!-- Passenger Catering (Departure) -->
                                <mat-accordion *ngIf="pax.departureCateringId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="passengerCateringLogsOpened.emit(pax.departureCateringId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Catering (Departure)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="passengerCateringLogsLoading"
                                        [loaded]="passengerCateringLogsLoaded"
                                        [audits]="passengerCateringLogs"
                                        [hasMore]="passengerCateringLogsHasMore"
                                        (nextPage)="passengerCateringLogsNextPage.emit(pax.departureCateringId)"
                                        noAuditsMessage="No audit records for catering"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>

                                <!-- Passenger Hotel (Departure) -->
                                <mat-accordion *ngIf="pax.departureHotelId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="passengerHotelLogsOpened.emit(pax.departureHotelId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Hotel (Departure)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="passengerHotelLogsLoading"
                                        [loaded]="passengerHotelLogsLoaded"
                                        [audits]="passengerHotelLogs"
                                        [hasMore]="passengerHotelLogsHasMore"
                                        (nextPage)="passengerHotelLogsNextPage.emit(pax.departureHotelId)"
                                        noAuditsMessage="No audit records for hotel"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>

                                <!-- Passenger Hotel (Arrival) -->
                                <mat-accordion *ngIf="pax.arrivalHotelId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="passengerHotelLogsOpened.emit(pax.arrivalHotelId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Hotel (Arrival)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="passengerHotelLogsLoading"
                                        [loaded]="passengerHotelLogsLoaded"
                                        [audits]="passengerHotelLogs"
                                        [hasMore]="passengerHotelLogsHasMore"
                                        (nextPage)="passengerHotelLogsNextPage.emit(pax.arrivalHotelId)"
                                        noAuditsMessage="No audit records for hotel"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>

                                <!-- Passenger Transportation (Departure) -->
                                <mat-accordion *ngIf="pax.departureTransportationId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="passengerTransportationLogsOpened.emit(pax.departureTransportationId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Transportation (Departure)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="passengerTransportationLogsLoading"
                                        [loaded]="passengerTransportationLogsLoaded"
                                        [audits]="passengerTransportationLogs"
                                        [hasMore]="passengerTransportationLogsHasMore"
                                        (nextPage)="passengerTransportationLogsNextPage.emit(pax.departureTransportationId)"
                                        noAuditsMessage="No audit records for transportation"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>

                                <!-- Passenger Transportation (Arrival) -->
                                <mat-accordion *ngIf="pax.arrivalTransportationId">
                                  <mat-expansion-panel
                                    class="nested-panel"
                                    (opened)="passengerTransportationLogsOpened.emit(pax.arrivalTransportationId)"
                                  >
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>Transportation (Arrival)</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                      <sd-portal-audit-detail-list-v2
                                        [loading]="passengerTransportationLogsLoading"
                                        [loaded]="passengerTransportationLogsLoaded"
                                        [audits]="passengerTransportationLogs"
                                        [hasMore]="passengerTransportationLogsHasMore"
                                        (nextPage)="passengerTransportationLogsNextPage.emit(pax.arrivalTransportationId)"
                                        noAuditsMessage="No audit records for transportation"
                                      ></sd-portal-audit-detail-list-v2>
                                    </ng-template>
                                  </mat-expansion-panel>
                                </mat-accordion>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>
                          <button
                            *ngIf="flightPassengersHasMore"
                            mat-button
                            color="primary"
                            (click)="flightPassengersNextPage.emit(leg.flightId)"
                          >
                            Load More
                          </button>
                        </div>
                      </ng-template>
                    </mat-expansion-panel>
                  </mat-accordion>
                </ng-template>
              </mat-expansion-panel>
              <button
                *ngIf="deletedTripLegsHasMore"
                mat-button
                color="primary"
                (click)="deletedTripLegsNextPage.emit(deletedTrip.id)"
              >
                Load More Legs
              </button>
            </div>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
